import React, { useState } from 'react';
import Mekelebanner from '../../../assets/images/icons/mekele.png';
import Dean from '../../../assets/images/icons/mekelle.jpg';
import MekeleStudent from '../../../assets/images/icons/mekelestudent.jpg';
import accreditationImage from '../../../assets/images/mek_acc1.jpg';
import accreditationImage1 from '../../../assets/images/mek_acc2.jpg';
import AccreditationModal from './AccreditationModal'; // Adjust the import path as necessary

const Mekele = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [currentImage, setCurrentImage] = useState('');

  const openModal = (image) => {
    setCurrentImage(image);
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
    setCurrentImage('');
  };

  return (
    <div>
      <div className="banner-slide">
        <img src={Mekelebanner} alt="Banner" className="banner-image" />
        <div className="banner-content">
          <h2>Empowering Students Through a Dedicated and Accomplished Faculty</h2>
          <p>Our faculty are highly qualified and dedicated to helping students reach their full potential.</p>
        </div>
      </div>

      <section className="projects-details">
        <div className="auto-container">
          <div className="sec-title style-two">
            <h3>MEKELLE CAMPUS</h3>
          </div>
          <div className="text-block">
            <div className="row">
              <div className="col-lg-6">
                <h4>MESSAGE FROM CAMPUS DEAN</h4>
                <div className="text">
                  <p>
                    Welcome to Admas University Mekelle Campus. We are committed to providing 
                    <strong> high-quality education, skill-based learning, and career-focused training</strong>. 
                    As a premier private university in Ethiopia, we empower students with the 
                    <strong> knowledge, innovation, and practical experience</strong> needed to excel in today’s competitive world.
                  </p>
                  <p>
                    Our campus offers a vibrant learning environment with 
                    <strong> state-of-the-art facilities, experienced faculty, and industry-aligned programs</strong>. 
                    We focus on equipping students with <em>critical thinking skills, problem-solving abilities, and leadership qualities</em> 
                    that prepare them for real-world challenges.
                  </p>
                  <p>
                    Whether you are a new student, a professional looking to upskill, or an industry leader seeking collaboration, 
                    <strong> Admas University Mekelle Campus</strong> provides the ideal platform for academic and career growth. 
                    Join us and be part of a university that is redefining excellence in higher education.
                  </p>
                  <h4>📍 Admas University Mekelle Campus – Your Path to Success!</h4>
                </div>
              </div>
              <div className="col-lg-6">
                <figure className="image pht">
                  <img src={Dean} alt="Dean" />
                  <figcaption>Yemane Reda (MA)</figcaption>
                </figure>
              </div>
            </div>
          </div>

          <div className="text-block">
            <div className="row">
              <div className="col-lg-6">
                <div className="sec-title style-two">
                  <h4>ACCREDITED PROGRAMS</h4>
                </div>
                <h6>Postgraduate Programs</h6>
                <ul className="services-list">
                  {['Accounting & Finance', 'Master of Business Administration', 'Project Management'].map((program, index) => (
                    <li key={index}>
                      <div className="icon-box">
                        <span className="flaticon-book"></span>
                        {program}
                      </div>
                    </li>
                  ))}
                </ul>

                <h6>UNDERGRADUATE PROGRAMS</h6>
                <ul className="services-list">
                  {['Accounting & Finance', 'Business Management', 'Marketing Management', 'Computer Science'].map((program, index) => (
                    <li key={index}>
                      <div className="icon-box">
                        <span className="flaticon-book"></span>
                        {program}
                      </div>
                    </li>
                  ))}
                </ul>

                <h6>TVET PROGRAMS</h6>
                <ul className="services-list">
                  {['Web Development & Database Administration Level 1-4', 'Hardware & Networking Servicing Level 1-4', 
                    'Secretarial Science & Office Administration Level 2-4', 'Marketing & Sales Management Level 2-4', 
                    'Food & Beverage Service Level 1-4', 'Housekeeping & Laundry Service Level 1-4', 
                    'Accounting & Finance Level 2-4', 'Tour Operation Level 2-4', 'Tour Guiding Level 2-4'].map((program, index) => (
                    <li key={index}>
                      <div className="icon-box">
                        <span className="flaticon-book"></span>
                        {program}
                      </div>
                    </li>
                  ))}
                </ul>
              </div>

              <div className="col-lg-6">
                <div className="map-container">
         <iframe
    src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3940.649357418435!2d38.763732072054275!3d9.004375791055955!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x164b85a3b294c027%3A0x5c059416ab392b2a!2zQWRtYXMgVW5pdmVyc2l0eSBIZWFkIE9mZmljZSB8IERlbWJlbCB8IOGKoOGLteGIm-GItSDhi6nhipLhiajhiK3hiLXhibIg4YuL4YqTIOGImC_hiaThibUgfCDhi7DhiJ3hiaDhiI0!5e0!3m2!1sen!2set!4v1744794076394!5m2!1sen!2set" width="600" height="450" style="border:0;" allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade" // <- Paste your actual embed URL here
    width="100%"
    height="100%"
    style={{ border: 0 }}
    allowFullScreen=""
    loading="lazy"
    referrerPolicy="no-referrer-when-downgrade"
    title="Admas University Meskel Campus Location"
  ></iframe>
      </div>
                <div className="accreditation">
                  <h5>CERTIFICATE OF ACCREDITATION</h5>
                  <img 
                    src={accreditationImage} 
                    alt="Accreditation Letter 1" 
                    style={{ width: '150px', cursor: 'pointer', marginRight: '10px' }} 
                    onClick={() => openModal(accreditationImage)} 
                  />
                  <img 
                    src={accreditationImage1} 
                    alt="Accreditation Letter 2" 
                    style={{ width: '150px', cursor: 'pointer' }} 
                    onClick={() => openModal(accreditationImage1)} 
                  />
                </div>
              </div>
            </div>
          </div>

          <div className="text-block-two">
            <div className="row">
              <div className="col-lg-6">
                <h4>STUDENT LIFE @ ADMASS UNIVERSITY MEKELLE CAMPUS</h4>
                <div className="text">
                  At Admas University Mekelle Campus, students enjoy a vibrant academic and social environment. The campus offers various extracurricular activities, clubs, and organizations that foster personal growth and community engagement.
                </div>
              </div>
              <div className="col-lg-6">
                <div className="image"><img src={MekeleStudent} alt="Students at Mekele Campus" /></div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <AccreditationModal 
        isOpen={isModalOpen} 
        onClose={closeModal} 
        images={[accreditationImage, accreditationImage1]} 
      />
    </div>
  );
};

export default Mekele;